<template>
  <j-form-container :disabled="disabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <!--label="结算依据"-->
            <a-form-item :label="$t('label.settlementBasis')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag type="list" v-decorator="['stlAccording',{'initialValue': '20'},validatorRules.stlAccording]" :trigger-change="true" dictCode="settle_according" :placeholder="$t('label.pleaseSelectTheBasisOfSettlement')" style="width: 84%"/>
            </a-form-item>
          </a-col>
          <!--<a-col :span="12">
            <a-form-item label="回收单价" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['recoverStandard', validatorRules.recoverStandard]" placeholder="请输入回收单价" style="width: 84%"/> 元/kg
            </a-form-item>
          </a-col>-->
          <a-col :span="12">
            <!--label="每只每日标准代养费"-->
            <a-form-item :label="$t('label.standardDailyFeePerAnimal')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['maintainPrice', validatorRules.maintainPrice]" :placeholder="$t('label.pleaseEnterTheStandardDailyFeePerAnimal')" style="width: 84%"/> {{ $t('label.yuanKg') }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="分红价格"-->
            <a-form-item :label="$t('label.dividendPrice')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['profitPrice', validatorRules.profitPrice]" :placeholder="$t('label.pleaseEnterTheDividendPrice')" style="width: 84%"/> {{ $t('label.yuanKg') }}
            </a-form-item>
          </a-col>
          <a-divider style="margin-bottom: 32px"/>
          <!--          <a-col :span="8">-->
<!--            <a-form-item label="养户" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <a-input v-decorator="['farmerCode']" placeholder="请输入养户"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
<!--          <a-divider style="margin-bottom: 32px"/>-->
<!--          <a-col :span="4">-->
<!--            <a-form-item v-has="'buffer4'" label="xxx" :labelCol="labelCol" :wrapperCol="wrapperCol">-->
<!--              <a-input v-decorator="['buffer4',{'initialValue': '1'}]" placeholder="xxx"></a-input>-->
<!--            </a-form-item>-->
<!--          </a-col>-->
          <a-col :span="12">
            <!--label="公司保本点"-->
            <a-form-item :label="$t('label.companyCapitalPreservationPoint')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['paBreakevenPoint', validatorRules.paBreakevenPoint]" :placeholder="$t('label.pleaseEnterTheCompanyCapitalPreservationPoint')" style="width: 84%"/> {{ $t('label.yuanKg') }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="养户保本点"-->
            <a-form-item :label="$t('label.capitalPreservationPointForFarmers')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['pbBreakevenPoint', validatorRules.pbBreakevenPoint]" :placeholder="$t('label.pleaseInputTheCapitalPreservationPointOfTheAdopter')" style="width: 84%"/> {{ $t('label.yuanKg') }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="甲方盈利比例"-->
            <a-form-item :label="$t('label.profitRatioOfPartyA')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['paProfitRatio', validatorRules.paProfitRatio]" :placeholder="$t('label.pleaseEnterTheProfitRatioOfPartyA')" style="width: 84%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="乙方盈利比例"-->
            <a-form-item :label="$t('label.profitRatioOfPartyB')"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['pbProfitRatio', validatorRules.pbProfitRatio]" :placeholder="$t('label.pleaseInputTheProfitRatioOfPartyB')" style="width: 84%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="甲方亏损比例"-->
            <a-form-item :label="$t('label.LossRatioOfPartyA')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['paLossRatio', validatorRules.paLossRatio]" :placeholder="$t('label.pleaseEnterThePercentageOfLossForPartyA')" style="width: 84%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="乙方亏损比例"-->
            <a-form-item  :label="$t('label.partyBLossRatio')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['pbLossRatio', validatorRules.pbLossRatio]" :placeholder="$t('label.pleaseInputLossRatioPartyB')" style="width: 84%"/> %
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="甲方结算金额"-->
            <a-form-item :label="$t('label.settlementAmountForPartyA')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['paStlAmount', validatorRules.paStlAmount]" placeholder="结算确认后更新" style="width: 84%"/> {{ $t('label.yuan') }}
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <!--label="乙方结算金额"-->
            <a-form-item :label="$t('label.settlementAmountOfPartyB')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled v-decorator="['pbStlAmount', validatorRules.pbStlAmount]" placeholder="结算确认后更新" style="width: 84%"/> {{ $t('label.yuan') }}
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </j-form-container>
</template>
<script>
  import pick from 'lodash.pick'
  import { getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'SettlementAllForm',
    components: {
      JFormContainer,
    },
    props:{
      disabled: {
        type: Boolean,
        default: false,
        required: false
      },
      // 当前table对应的数据表名
      tableName: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        validatorRules: {
          stlAccording: {
            rules: [
              { required: true, message: this.$t('label.pleaseSelectTheBasisOfSettlement')},
            ]
          },
         /* recoverStandard: {
            rules: [
              { required: true, message: '请输入回收单价!'},
              { pattern: /^-?\d+\.?\d*$/, message: '请输入数字!'},
            ]
          },*/
          maintainPrice: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheStandardDailyFeePerAnimal')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          profitPrice: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheDividendPrice')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          paBreakevenPoint: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheCompanyCapitalPreservationPoint')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          pbBreakevenPoint: {
            rules: [
              { required: true, message: this.$t('label.pleaseInputTheCapitalPreservationPointOfTheAdopter')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          paProfitRatio: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterTheProfitRatioOfPartyA')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          pbProfitRatio: {
            rules: [
              { required: true, message: this.$t('label.pleaseInputTheProfitRatioOfPartyB')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          paLossRatio: {
            rules: [
              { required: true, message: this.$t('label.pleaseEnterThePercentageOfLossForPartyA')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          pbLossRatio: {
            rules: [
              { required: true, message: this.$t('label.pleaseInputLossRatioPartyB')},
              { pattern: /^-?\d+\.?\d*$/, message: this.$t('label.pleaseEnteANumber')},
            ]
          },
          paStlAmount: {
            rules: [
              { required: false},
              { pattern: /^(([1-9][0-9]*)|([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2}))$/, message: this.$t('label.pleaseEnterTheCorrectAmount')},
            ]
          },
          pbStlAmount: {
            rules: [
              { required: false},
              { pattern: /^(([1-9][0-9]*)|([0]\.\d{0,2}|[1-9][0-9]*\.\d{0,2}))$/, message: this.$t('label.pleaseEnterTheCorrectAmount')},
            ]
          },
        },
        confirmLoading: false,
      }
    },
    methods:{
      initFormData(url,id){
        this.clearFormData()
        if(!id){
          this.edit({})
        }else{
          getAction(url,{id:id}).then(res=>{
            if(res.success){
              let records = res.result
              if(records && records.length>0){
                this.edit(records[0])
              }
            }
          })
        }
      },
      edit(record){
        this.model = Object.assign({}, record)
        console.log("SettlementAllForm-edit",this.model);
        let fieldval = pick(this.model,'stlAccording','recoverStandard','maintainPrice','profitPrice','paProfitRatio','paBreakevenPoint','pbBreakevenPoint','pbProfitRatio','paLossRatio','pbLossRatio','paStlAmount','pbStlAmount','buffer4')
        this.$nextTick(() => {
          this.form.setFieldsValue(fieldval)
        })
      },
      getFormData(){
        let formdata_arr = []
        this.form.validateFields((err, values) => {
          if (!err) {
            let formdata = Object.assign(this.model, values)
            let isNullObj = true
            Object.keys(formdata).forEach(key=>{
              if(formdata[key]){
                isNullObj = false
              }
            })
            if(!isNullObj){
              formdata_arr.push(formdata)
            }
          }else{
            this.$emit("validateError",this.$t('tip.contractBreakdownSheetFailedTo'));
          }
        })
        console.log("合同明细表单数据集",formdata_arr);
        return formdata_arr;
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'stlAccording','recoverStandard','maintainPrice','profitPrice','paProfitRatio','paBreakevenPoint','pbBreakevenPoint','pbProfitRatio','paLossRatio','pbLossRatio','paStlAmount','pbStlAmount','buffer4'))
      },
      clearFormData(){
        this.form.resetFields()
        this.model={}
      },
    }
  }
</script>
